'use memo';

import { createFileRoute } from '@tanstack/react-router';

import { PersonAggregateHistoryPage } from '@/features/history-v2';
import usePersonParams from '@/routes/_staff/person/$id/-hooks/usePersonParams';
import useGetPersonAggregateEvents from '@/routes/_staff/person/$id/_profile/history/-queries/useGetPersonAggregateEvents';

export const Route = createFileRoute(
  '/_staff/person/alumni/$id/_profile/history/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = usePersonParams();
  const { data } = useGetPersonAggregateEvents({ personId: id });

  return <PersonAggregateHistoryPage data={data} />;
}
